var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.999 0A6.006 6.006 0 000 6c0 1.035.27 2.055.78 2.951a6.037 6.037 0 002.085 2.158c.944.582 2.029.89 3.135.89 3.309 0 6-2.691 6-5.999a6.009 6.009 0 00-6.001-6zm0 11.145a5.115 5.115 0 01-2.687-.763 5.177 5.177 0 01-1.79-1.854A5.12 5.12 0 01.854 6 5.153 5.153 0 016 .853 5.153 5.153 0 0111.147 6a5.153 5.153 0 01-5.148 5.145z","key":0}),React.createElement("path",{"d":"M6.215 6.483l.001-2.835a.427.427 0 00-.853 0l-.001 3.013.035.165a.41.41 0 00.093.138l1.688 1.687a.435.435 0 00.604-.001.427.427 0 000-.603L6.215 6.483z","key":1})]);
}

Clock.defaultProps = {"width":"12","height":"11.999","viewBox":"0 0 12 11.999"};

module.exports = Clock;

Clock.default = Clock;
